import * as ActionTypes from '../constants/actionTypes'
import CryptoJS from 'crypto-js'
import config from '../config/index'

export const login = values => (dispatch) => {
  localStorage.setItem('sessionId', values.sessionId)
  localStorage.setItem('userId', CryptoJS.AES.encrypt(values.userId, config.api.cryptoKey).toString())
  localStorage.setItem('isEPO', values.isEPO)
  localStorage.setItem('isFullRoot', CryptoJS.AES.encrypt(values.isFullRoot, config.api.cryptoKey).toString())
  dispatch({ type: ActionTypes.APP_LOGIN_SET, sessionId: values.sessionId })
}

export const param = values => (dispatch) => {
  dispatch({ type: ActionTypes.PARAM_SET, params: values.params })
}

export const logout = () => (dispatch) => {
  localStorage.removeItem('sessionId')
  localStorage.removeItem('userId')
  localStorage.removeItem('isEPO')
  localStorage.removeItem('isFullRoot')
  dispatch({ type: ActionTypes.APP_LOGOUT_SET })
}



// WEBPACK FOOTER //
// src/actions/app.js